
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/AboutPayPal",
      function () {
        return require("private-next-pages/article/AboutPayPal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/AboutPayPal"])
      });
    }
  